import { bindRequestLogic } from './utils'
import Portal from '../actionTypes/portal'
import { portalAPI } from '../api'

const getPortals = bindRequestLogic({
  clientFunc: portalAPI.getPlatformTechs,
  type: Portal.GET_PORTALS_REQUEST,
  successType: Portal.GET_PORTALS_SUCCESS,
  failedType: Portal.GET_PORTALS_FAILED
})

export default [getPortals]
